import { getQuery, getLimitOptions } from 'utilities/query';
import templateUrl from './treat-admin-list.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    administrations: '<',
    selectedAdministrations: '<',
    units: '<',
    unitsDisplay: '<',
    unitPerContainer: '<',
    locked: '<',
    showHeader: '<'
  },
  controller: class TreatAdminListComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    $onInit() {
      this.query = getQuery();
      this.limitOptions = getLimitOptions();
      this.administrations = this.administrations.filter(a => a.Isloading === false);
    }

    $onChanges() {
      this.administrations = this.administrations.filter(a => a.Isloading === false);
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/product/treat-admin-list/treat-admin-list.component.js